import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Iomagg002 from "../assets/img/favicon.png";
import FeatherIcon from "feather-icons-react";

const Header = (props) => {
  const history = useHistory();
  const [user, setUser] = useState([]);

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const onMenuClik = () => {
    // eslint-disable-next-line react/prop-types
    props.onMenuClick();
  };

  useEffect(() => {
    console.log = function() {};
    const user = JSON.parse(localStorage.getItem("user"));
    console.log("user in localStorage", user);

    setUser(user);

    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    };

    const maximizeBtn = document.querySelector(".win-maximize");
    maximizeBtn.addEventListener("click", handleClick);

    return () => {
      maximizeBtn.removeEventListener("click", handleClick);
    };
  }, []);

  const handleLogout = () => {
    // Clear all localStorage items
    localStorage.clear();

    // Redirect to login page
    history.push("/login");
  };

  return (
    <div className="header header-one">
      <Link
        to="dashboard"
        className="d-inline-flex d-sm-inline-flex align-items-center d-md-inline-flex d-lg-none align-items-center device-logo"
      >
        <img src={Iomagg002} className="img-fluid logo2" alt="Logo" />
      </Link>
      <div className="main-logo d-inline float-start d-lg-flex align-items-center d-none d-sm-none d-md-none">
        <div className="logo-white">
          <Link to="dashboard">
            <img src={Iomagg002} className="img-fluid logo-blue" alt="Logo" />
          </Link>
          <Link to="dashboard">
            <img src={Iomagg002} className="img-fluid logo-small" alt="Logo" />
          </Link>
        </div>
        <div className="logo-color">
          <Link to="dashboard">
            <img src={Iomagg002} className="img-fluid logo-blue" alt="Logo" />
          </Link>
          <Link to="dashboard">
            <img src={Iomagg002} className="img-fluid logo-small" alt="Logo" />
          </Link>
        </div>
      </div>
      {/* Sidebar Toggle */}
      <Link to="#" id="toggle_btn" onClick={handlesidebar}>
        <FeatherIcon icon="menu" />
      </Link>
      {/* /Sidebar Toggle */}

      {/* Mobile Menu Toggle */}
      <Link
        to="#"
        className="mobile_btn"
        id="mobile_btn"
        onClick={() => onMenuClik()}
      >
        <i className="fas fa-bars" />
      </Link>
      {/* /Mobile Menu Toggle */}

      {/* Header Menu */}
      <ul className="nav nav-tabs user-menu">
        <li className="nav-item  has-arrow dropdown-heads ">
          <Link to="#" className="win-maximize">
            <i className="fe fe-maximize" />
          </Link>
        </li>
        {/* User Menu */}
        <li className="nav-item dropdown">
          <Link
            to="/profile"
            className="user-link  nav-link"
            data-bs-toggle="dropdown"
          >
            <span className="user-img">
              {user.Profile ? (
                <img
                  src={`https://api.cenpilot.in${user.Profile}`}
                  alt="img"
                  className="profilesidebar"
                />
              ) : (
                <img
                  src={`https://images.squarespace-cdn.com/content/v1/6204821bfe06b76898b431c5/ff6521b0-95d6-460e-ba57-59700435d24f/EE7A0433-2.jpg`}
                  alt="img"
                  className="profilesidebar"
                />
              )}
              <span className="animate-circle" />
            </span>
            <span className="user-content">
              <span className="user-details">Admin</span>
              {user.Name && <span className="user-name">{user.Name}</span>}
            </span>
          </Link>
          <div className="dropdown-menu menu-drop-user">
            <div className="profilemenu">
              <div className="subscription-menu">
                <ul>
                  <li>
                    <Link className="dropdown-item" to="/profile">
                      Profile
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="subscription-logout">
                <ul>
                  <li className="pb-0">
                    <Link
                      className="dropdown-item"
                      to="/login"
                      onClick={handleLogout}
                    >
                      Log Out
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};
export default Header;
